<template>
   <div id="tax-setting" class="rounded-item shadow-md">
    <vx-card>
      <div class="setting-card-hidden">
        <div class="setting-card-scroll">
          <div class="vx-row mx-0 mb-6">
            <div class="vx-col ml-0 sm:w-1/4 w-full flex align-center">
              <span>Service Tax(%)</span>
            </div>
            <div class="vx-col mr-0 sm:w-3/4 w-full">
              <vs-input class="w-full" v-model="service_tax"/>
            </div>
          </div>
          <div class="vx-row mx-0 mb-6">
            <div class="vx-col ml-0 sm:w-1/4 w-full flex align-center">
              <span>Product Tax(%)</span>
            </div>
            <div class="vx-col mr-0 sm:w-3/4 w-full">
              <vs-input class="w-full" v-model="product_tax" />
            </div>
          </div>
          <div class="vx-row mx-0">
            <div class="vx-col mr-0 sm:w-3/4 w-full ml-auto">
              <vs-button class="mr-3 mb-2" style="min-width: 140px;" @click="changeTax">Submit</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: 'tax-setting',
  data(){
    return{
      service_tax: 0,
      product_tax: 0,
      taxSetting: [],
    }
  },
  methods: {
    changeTax(){
      const obj = {
        service_val : +(Math.round(this.service_tax/100 + "e+8") + "e-8"),
        product_val : +(Math.round(this.product_tax/100 + "e+8") + "e-8")
      }
      this.$store.dispatch("appSetting/UPDATE_TAX", obj).then(() => {
        this.$vs.notify({
          title:'Success',
          text:'Update Tax Setting Success',
          color:'success',
          position:'top-right'
        })
      }).catch((err) => {
        this.$vs.notify({
          title:'Fail',
          text: err,
          color:'danger',
          position:'top-right'
        })
      })
    }
  },
  created(){
    this.$store.dispatch("appSetting/GET_TAX").then(() => {
      this.taxSetting = this.$store.state.appSetting.taxSetting;
      for(let i = 0;i<this.taxSetting.length; i++){
        if(this.taxSetting[i].type == 'service'){
          this.service_tax = +(Math.round(this.taxSetting[i].value*100 + "e+4") + "e-4");
        }
        if(this.taxSetting[i].type == 'product'){
          this.product_tax = +(Math.round(this.taxSetting[i].value*100 + "e+4") + "e-4");
        }
      }
    })
  }
}
</script>
